const DECIMAL_TO_FRACTIONAL_FACTOR = 0.0501;

export const fractionalToDecimal = (fracOdds: string): number => {
  const [num, den] = fracOdds.split("/");
  return Math.round((Number(num) / Number(den) + 1) * 1000) / 1000;
};

export const americanToDecimal = (amOdds: string): number => {
  const integer = parseInt(amOdds.substring(1));
  const decOdds: number =
    (amOdds.includes("+") && integer / 100 + 1) ||
    (amOdds.includes("-") && 100 / integer + 1) ||
    0;
  return Math.round(decOdds * 1000) / 1000;
};

export const decimalToFractional = (
  decOdds: number,
  combined: boolean
): string => {
  const oddsSub = decOdds - 1;
  if (combined) {
    return (Math.round(oddsSub * 100) / 100).toString().concat("/1");
  } else {
    let i = 1;
    while (
      Math.abs(oddsSub * i - Math.round(oddsSub * i)) >
      DECIMAL_TO_FRACTIONAL_FACTOR
    ) {
      i++;
    }
    const num = Math.round(oddsSub * i);
    const den = i.toString();

    return `${num}/${den}`;
  }
};

export const decimalToAmerican = (decOdds: number): string => {
  return decOdds >= 2
    ? `+${Math.round((decOdds - 1) * 100).toString()}`
    : `-${Math.round(100 / (decOdds - 1)).toString()}`;
};
const getTotalOdds = (oddsValue: any, oddsFormat: string) => {
  if (oddsFormat === "DECIMAL") {
    return parseFloat(parseFloat(oddsValue).toFixed(3));
  } else if (oddsFormat === "FRACTIONAL") {
    const odds = fractionalToDecimal(oddsValue);
    return parseFloat(odds.toFixed(3));
  } else {
    const odds = americanToDecimal(oddsValue);
    return parseFloat(odds.toFixed(3));
  }
};
const getTotalFormattedOdds = (rate: number, isCombined: boolean) => {
  return {
    american: decimalToAmerican(rate),
    decimal: rate.toFixed(2),
    fractional: decimalToFractional(rate, isCombined),
  };
};

export const getTotalReturn = (
  stake: number,
  oddsValue: string,
  oddsFormat: string,
  isCombined: boolean
) => {
  const rate = getTotalOdds(oddsValue, oddsFormat);

  return (
    Math.round(
      (stake * parseFloat(getTotalFormattedOdds(rate, isCombined).decimal) +
        Number.EPSILON) *
        100
    ) / 100
  );
};

export const parseDecimal = (value: any) => {
  //delete all non-numeric characters but commas and dots
  let parsed = value.replace(/^(-)|[^0-9.,]+/g, "");
  //if comma replace with dot
  if (parsed.endsWith(",")) {
    parsed = parsed.replace(",", ".");
  }

  const hasMoreThanOneDot = (parsed.split(".") || []).length > 2;

  if (hasMoreThanOneDot) {
    parsed = parsed.slice(0, parsed.lastIndexOf("."));
  }

  if (parsed.endsWith(".")) {
    const oldStr = parsed.slice(0, -1);
    //if it ends with a dot but the rest of the string already had decimal, delete last dot
    if (oldStr.includes(".")) {
      parsed = parsed.slice(0, -1);
    }
  }
  //prevent smaller than 1 numbers
  if (parsed < 1 || parsed.endsWith("-")) {
    parsed = parsed.slice(0, -1);
  }
  return parsed;
};

export const parseFractional = (value: any) => {
  //delete all non-numeric characters but "/"
  let parsed = value.replace(/^(-)|[^0-9/]+/g, "");
  // can't start with "/""
  if (parsed.endsWith("/") && parsed.length === 1) {
    parsed = parsed.slice(0, -1);
  }
  //can't have two "/"
  if (parsed.split("/").length - 1 > 1) {
    parsed = parsed.substring(0, 3);
  }
  //first integer can't be smaller than 1
  if (!parsed.includes("/") && parsed === "0") {
    parsed = parsed.slice(0, -1);
  }
  //second integer can't be smaller than 1
  if (
    parsed.includes("/") &&
    parsed.endsWith("0") &&
    parsed.charAt(parsed.length - 2) === "/"
  ) {
    parsed = parsed.slice(0, -1);
  }
  //If the first integer > 1, the second integer has to be ≤ 20
  if (parsed.includes("/")) {
    const ls = parsed.split("/");
    if (ls[0] > 1 && ls[1] > 20) {
      parsed = parsed.slice(0, -1);
    }
  }

  return parsed;
};
export const parseAmerican = (value: string) => {
  //delete all non-numeric characters but + and -
  let parsed = value.replace(/[^0-9\-+]/g, "");
  //has to start with + or - (defaults to +)
  if (parsed.charAt(0) !== "+" && parsed.charAt(0) !== "-") {
    if (parsed.length !== 0) {
      parsed = "+" + parsed;
    }
  }
  //avoid duplicate +/- signs
  if (parsed.length > 1) {
    if (parsed.endsWith("+") || parsed.endsWith("-")) {
      parsed = parsed.slice(0, -1);
    }
    //can't start with 0
    if (parsed.charAt(1) === "0") {
      parsed = parsed.slice(0, -1);
    }
  }

  return parsed;
};
